export default "__VITE_ASSET__DZquq0F9__"